/**
 * Created by siraz on 19/08/22.
 */
(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name simUtilizationReport.directive:simUtilizationReportSearch
   * @restrict EA
   * @element
   *
   */
  angular
    .module('simUtilizationReport')
    .directive('simUtilizationReportSearch', simUtilizationReportSearch)
    .directive('focusOn',function($timeout) {
      return {
        restrict : 'A',
        link : function(vm,$element,$attr) {
          vm.$watch($attr.focusOn,function(_focusVal) {
            $timeout(function() {
              _focusVal ? $element[0].focus() :
                $element[0].blur();
            });
          });
        }
      }
    });


  function simUtilizationReportSearch(MessageService,applicationConstants) {
    return {
      restrict: 'EA',
      scope: {
        changeSearchField:'&',
        onSearchSimUtilization:'&',
        aircraftTypes:'=',
        showSearchArea:'=',
        trainingCrewType:'=',
        trainingProgramCode:'=',
        trainingLocation:'=',
        trainersList:'=',
        traineesList:'=',
        crewNameList:'=',
        trainingProgramDesc:'='
      },
      templateUrl: 'sim-utilization-report/directives/sim-utilization-report-search-directive.tpl.html',
      replace: false,
      controllerAs: 'simUtilizationReportSearch',
      bindToController: true,
      controller: [ function () {
        var vm = this;
        vm.showSearchArea = true;
        vm.model ={
          startDate : "",
          endDate : "",
          aircraftModelDetails :{model:''},
          trainingCrewTypeDetails:{crewTypeCode:''},
          trainingProgramCodeDetails:'',
          trainingProgramDescDetails:'',
          trainingLocationDetails:{locationCode:''},
          trainerDetails:'',
          traineeDetails:''
        };
        vm.masterList = {
          fromDateFormatInvalid: false,
          toDateFormatInvalid: false,
          fromDateAfterToDate: false,
        }

        setDefaultSearchDays();

        vm.displaySearchArea = function () {
          vm.showSearchArea = !vm.showSearchArea;
          // vm.openSearchPanel();
        };

        vm.changeDate = function (flag) {
          var tempFromDate = moment(vm.model.startDate, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
          if((flag.toUpperCase()==='FROMDATE') &&
            (!!vm.model.endDate && !!vm.model.startDate)){
            var fD = moment(vm.model.startDate, applicationConstants.SETTINGS.DATE_FORMAT);
            var eD = moment(vm.model.endDate, applicationConstants.SETTINGS.DATE_FORMAT);
            if(eD.diff(fD) < 0){
              vm.model.endDate = vm.model.startDate;
            }
          }
        };

        vm.changeField = function(flag){
          vm.changeSearchField({searchParams:vm.model,flag:flag});
        }


        function setDefaultSearchDays(){
          if(!vm.model.startDate){
            var moStart = moment().startOf("month");
            var moEnd = moment().endOf("month");
            vm.model.startDate = moStart.format(applicationConstants.SETTINGS.DATE_FORMAT);
            vm.model.endDate = moEnd.format(applicationConstants.SETTINGS.DATE_FORMAT);
          }
        }

        vm.changeToDate = function (flag,date) {
          vm.model.endDate = date;
        };

        vm.onSearchClick = function () {
          vm.showSearchArea = false;
          vm.onSearchSimUtilization({searchParam:vm.model});
        };

      }],

      link: function (scope, element, attrs) {

      }

    };
  }
}());
